import { applyMiddleware, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import createRootReducer, { combinedActionCreators } from './reducers';
import rootEpic from './epics';

const epicMiddleware = createEpicMiddleware(rootEpic, {
  dependencies: { fetch },
});
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
  actionCreators: combinedActionCreators,
});

const configureStore = (history) => {
  const store = createStore(
    createRootReducer(history),
    composeEnhancers(applyMiddleware(epicMiddleware, routerMiddleware(history))),
  );

  return store;
};

export default configureStore;
